import { render, staticRenderFns } from "./TaskgroupHeader.vue?vue&type=template&id=1c2c0a40"
import script from "./TaskgroupHeader.vue?vue&type=script&lang=js"
export * from "./TaskgroupHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports